import { Quantity } from '@app/generated/graphql';

export const PALLETS_PER_CONTAINER = 20;

export abstract class QuantityHelper {
  static convertQuantity(
    quantity: number,
    palletStack: number,
    fromUnit: Quantity,
    toUnit: Quantity,
  ): number {
    if (!quantity || !fromUnit || !toUnit) {
      return quantity;
    }

    if (fromUnit === toUnit) {
      return quantity;
    }

    switch (fromUnit) {
      case Quantity.Carton:
        if (toUnit === Quantity.Pallet) {
          return quantity / palletStack;
        }
        if (toUnit === Quantity.Container) {
          return quantity / palletStack / PALLETS_PER_CONTAINER;
        }
        break;
      case Quantity.Pallet:
        if (toUnit === Quantity.Carton) {
          return quantity * palletStack;
        }
        if (toUnit === Quantity.Container) {
          return quantity / PALLETS_PER_CONTAINER;
        }
        break;
      case Quantity.Container:
        if (toUnit === Quantity.Carton) {
          return quantity * palletStack * PALLETS_PER_CONTAINER;
        }
        if (toUnit === Quantity.Pallet) {
          return quantity * PALLETS_PER_CONTAINER;
        }
    }
  }

  static quantityType(quantityUnit: string): Quantity {
    if (quantityUnit === 'pallet') {
      return Quantity.Pallet;
    }
    if (quantityUnit === 'carton') {
      return Quantity.Carton;
    }
    if (quantityUnit === 'container') {
      return Quantity.Container;
    }
  }
}
